import React from "react";
import {PaymentPartnerOnBoardForm} from '../components';

export const PaymentPartnerOnboardDetailsPage: React.FC = () => <PaymentPartnerOnBoardForm />;